function Science() {
  return <h1>Science</h1>;
}

export default Science;